import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { API_PATHS } from '../constants/api.constants';
import { AuthService } from '../services/auth.service';

/** The API says "jwt expired"; the user needs to be told to sign in again. */
export const sessionExpiryInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  return next(req).pipe(
    catchError((error: unknown) => {
      if (isExpiredSession(req.url, error)) {
        auth.expireSession();
      }
      return throwError(() => error);
    }),
  );
};

function isExpiredSession(url: string, error: unknown): boolean {
  if (!(error instanceof HttpErrorResponse) || error.status !== 401) {
    return false;
  }
  // A 401 from another host is not ours to read.
  if (!url.startsWith(environment.apiBaseUrl)) {
    return false;
  }
  // On sign-in a 401 is a wrong password, and signing out is already leaving.
  return !url.endsWith(API_PATHS.loginUser) && !url.endsWith(API_PATHS.logOutUser);
}
